import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';

export class BusinessSplitController extends BasesController<any> {
  constructor(public Store) {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      details: EnumAPI.business_priceSheetSplit,
      detailsParams: {
        valueGetter: this.valueGetter,
      },
    });
  }
  cacheData = [];
  valueGetter = (response) => {
    const dataSource = Promise.all(
      lodash.map(response, async (item) => {
        const productIds = lodash.map(item.productList, (productItem) => {
          //选择店铺
          productItem.selectShop = {};
          return productItem.productId;
        });
        const selectAddress =
          this.Store.BusinessAddressController.selectAddress;
        const curAddress = selectAddress[item.distributorCode];
        const res: any = await this.getAddressList(item, productIds);
        let firstInfo: any = {};

        if (lodash.size(res.addressList)) {
          if (curAddress) {
            const data = lodash.find(res.addressList, { id: curAddress.id });
            if (data) {
              firstInfo = curAddress;
            } else {
              firstInfo = lodash.get(res.addressList, '[0]');
            }
          } else {
            firstInfo = lodash.get(res.addressList, '[0]');
            this.Store.BusinessAddressController.setDistributorCode(
              item.distributorCode,
            );
            this.Store.BusinessAddressController.onSelectAddress(firstInfo);
          }
        }

        return lodash.assign({}, item, {
          isDefault: lodash.isEmpty(firstInfo) ? false : true,
          defaultAddress: firstInfo,
          consignee: firstInfo.consignee,
          details: firstInfo.details,
          mobile: firstInfo.mobile,
          productIds: productIds,
        });
      }),
    );
    return dataSource;
  };
  ShopController = new BasesController({
    dataKey: 'shopId',
    infinite: true,
    pagination: EnumAPI.business_getShopInfo,
  });

  changeDefaultAddress(item) {
    const cur = lodash.filter(this.dataSource, [
      'distributorCode',
      item.distributorCode,
    ]);
    lodash.assign(cur, {
      isDefault: true,
      defaultAddress: item,
    });
  }

  async getAddressList(item, productIds) {
    const res = await this.onBusinessFindAddressList({
      distributorCode: item.distributorCode,
      productIds: lodash.uniq(productIds),
    });
    return res;
  }
  /**
   * @des 收货地址列表查询
   */
  async onBusinessFindAddressList(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_findAddressList,
      body,
    });
  }

  /**
   * @des 转单提交
   */
  async onBusinessTransferOrder(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_transferOrder,
      body,
    });
  }
  /**
   * @description: 获取店面信息
   * @param {*} Entity
   * @return {*}
   */
  async getShopInfo(Entity) {
    return await AjaxBasics.request(
      lodash.assign({}, EnumAPI.business_getShopInfo, {
        body: Entity,
      }),
    );
  }
}
